import React, { useState } from "react";
import { Form, Input, notification, Select } from "antd";
import {
  useCreateAreaMutation,
  useGetAreaDropdownQuery,
  useGetPermissionsQuery,
  useGetSubAreaDropdownQuery,
  useGetSubZoneDropdownQuery,
  useGetZoneDropdownQuery,
} from "@services/api/";
import AppFormWrapper from "@components/appFormWrapper";
import { areaValidator } from "@validators/areaValidator";
import NotificationHandler from "@components/notificationHandler";

const { Option } = Select;

interface AddAreaProps {
  onClose?: () => void;
}

const AddArea: React.FC<AddAreaProps> = ({ onClose }) => {
  const [form] = Form.useForm();
  const { openNotificationWithIcon } = NotificationHandler();
  const [createArea, { isLoading, error }] = useCreateAreaMutation();
  const [selectedZoneId, setSelectedZoneId] = useState<string | null>("");
  const [selectedSubZoneId, setSelectedSubZoneId] = useState<string | null>("");
  const [selectedAreaId, setSelectedAreaId] = useState<string | null>("");
  const {
    data: permissions,
    error: permissionsError,
    isLoading: permissionsIsLoading,
  } = useGetPermissionsQuery();
  const {
    data: subZone,
    error: subZoneError,
    isLoading: subZoneIsLoading,
    refetch: refetchSubZone,
  } = useGetSubZoneDropdownQuery({});

  const onFinish = async (values: any) => {
    try {
      let permissionIds: string[] = [];

      for (const value of Object.values(values)) {
        if (value && Array.isArray(value)) {
          permissionIds = permissionIds.concat(value);
        }
      }
      const payload = {
        name: values.name,
        subZoneId: values.subZoneId,
      };
      const result = await createArea(payload).unwrap();
      console.log("Area Added successfully:", result);
      openNotificationWithIcon(
        "success",
        result?.message || "Area Created Successfully!"
      );
      onClose && onClose();
    } catch (err: any) {
      console.error("Area creation failed:", err);
      // openNotificationWithIcon("error", err?.data?.message);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <AppFormWrapper
      form={form}
      error={error || permissionsError}
      initialValues={{ name: null, permissions: null }}
      isLoading={isLoading || permissionsIsLoading}
      onClose={onClose}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      type="Add"
    >
      <Form.Item label="Name" name="name" rules={areaValidator.name}>
        <Input
          maxLength={30}
          className="rounded-md p-1 border-gray-300 focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-50"
          placeholder="Enter name"
          disabled={isLoading}
        />
      </Form.Item>
      <Form.Item
        label="Sub Zone"
        name="subZoneId"
        rules={areaValidator.subZone}
      >
        <Select
          showSearch
          optionFilterProp="children"
          placeholder="Select sub zone"
          loading={subZoneIsLoading}
          disabled={subZoneIsLoading || isLoading}
          className="rounded-md"
        >
          {subZone?.data?.map((value) => (
            <Option key={value.id} value={value.id}>
              {value.name}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </AppFormWrapper>
  );
};

export default AddArea;
